<template lang="pug">
#scroll_heatmap
  template(v-if="$store.state[this.state_name].show_scroll_heatmap")
    .gradient(:style="{ backgroundImage: gradient}", v-if="(!$store.state[this.state_name].simul_display && !$store.state[this.state_name].show_attention_heatmap) || ($store.state[this.state_name].simul_display && $store.state[this.state_name].show_scroll_heatmap)")
    .chart_line(v-for="(v, i) in this.$store.state[this.state_name].scroll_data", :style="{ top: marginTop(i) }")
      .balloon(:style="{ marginLeft: BalloonLeft(v) }") 
        span.balloon_type scroll
        span.balloon_text {{v}}%
      .chart_unit
        .chart_bold(:style="{ width: widthBold(v) }")
        .chart_thin(:style="{ width: widthThin(v) }")
</template>

<script>
import Vue from 'vue'

export default {
  props: {
    token: String,
    state_name: {
      type: String,
      default: "heatmap"
    },
  },
  data(){
    return {
      page_height: 0,
      show_heatmap: false
    }
  },
  methods: {
    async initIframe(){
      this.$store.commit(`${this.state_name}/setToken`, this.token)
      await this.$store.dispatch(`${this.state_name}/getScroll`)
    },
    getData(){
    },
    marginTop(i){
      //console.log(i, this.page_height);
      return (this.$store.state[this.state_name].page_height/100)*i -50 + "px"
    },
    widthBold(v){
      //console.log(i, this.page_height);
      return v + "%"
    },
    widthThin(v){
      //console.log(i, this.page_height);
      return (100-v) + "%"
    },
    BalloonLeft(v){
      return "calc(" + v + "% - 10px)"
    },
  },
  async mounted(){
    await Vue.nextTick()
    await this.initIframe()
  },
  watch: {
    device: async function (val) {
      await this.initIframe()
    },
  },
  components: {
  },
  computed: {
    gradient() {
      return this.$store.getters[`${this.state_name}/gradient`];
    },
    device(){
      return this.$store.state[this.state_name].device;
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
